import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoDollarSignSolid = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_27551_8993)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M14.5636 11.1016C15.3058 11.3359 15.9308 11.7656 16.4777 12.3125C17.0245 12.8984 17.3761 13.5625 17.5323 14.3438C17.6886 15.125 17.6495 15.8672 17.4152 16.6484C17.1027 17.5078 16.5558 18.2109 15.8136 18.7188C15.0323 19.2266 14.212 19.5 13.2745 19.5V21.375C13.2745 21.5703 13.1964 21.7266 13.0792 21.8438C12.962 21.9609 12.8058 22 12.6495 22H11.3995C11.2042 22 11.048 21.9609 10.9308 21.8438C10.8136 21.7266 10.7745 21.5703 10.7745 21.375V19.5C9.52454 19.5 8.39172 19.1094 7.3761 18.3281C7.21985 18.2109 7.14172 18.0547 7.14172 17.8594C7.10266 17.7031 7.18079 17.5078 7.33704 17.3516L8.66516 16.0234C8.74329 15.9453 8.86047 15.9062 9.01672 15.8672C9.17297 15.8672 9.29016 15.9062 9.44641 15.9844C9.83704 16.2578 10.2667 16.375 10.7745 16.375H13.3917C13.7042 16.375 13.9386 16.2969 14.173 16.0625C14.4073 15.8281 14.5245 15.5547 14.5245 15.2031C14.5245 14.9688 14.4464 14.7734 14.2902 14.5391C14.1339 14.3438 13.9386 14.1875 13.7042 14.1094L9.68079 12.9375C8.78235 12.7031 8.04016 12.2344 7.45422 11.5312C6.82922 10.8672 6.47766 10.0859 6.39954 9.1875C6.32141 8.36719 6.47766 7.58594 6.86829 6.88281C7.21985 6.17969 7.72766 5.59375 8.43079 5.16406C9.09485 4.73438 9.83704 4.5 10.6964 4.5H10.7745V2.625C10.7745 2.46875 10.8136 2.3125 10.9308 2.19531C11.048 2.07812 11.2042 2 11.3995 2H12.6495C12.8058 2 12.962 2.07812 13.0792 2.19531C13.1964 2.3125 13.2745 2.46875 13.2745 2.625V4.5C14.5245 4.5 15.6183 4.89062 16.6339 5.67188C16.7902 5.82812 16.8683 5.98438 16.9073 6.14062C16.9073 6.33594 16.8683 6.49219 16.712 6.60938L15.3839 7.97656C15.2667 8.05469 15.1495 8.13281 14.9933 8.13281C14.837 8.17188 14.7198 8.13281 14.6027 8.05469C14.212 7.78125 13.7433 7.625 13.2745 7.625H10.6573C10.3448 7.625 10.0714 7.74219 9.83704 7.97656C9.60266 8.21094 9.52454 8.48438 9.52454 8.79688C9.52454 9.03125 9.60266 9.26562 9.75891 9.46094C9.91516 9.69531 10.1105 9.8125 10.3448 9.89062L14.5636 11.1016Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: .5,
				y: .5,
				width: 23,
				height: 23,
				rx: 11.5,
				stroke: "currentColor"
			}),
			/* @__PURE__ */ _jsx("line", {
				x1: 3.65803,
				y1: 19.6352,
				x2: 19.658,
				y2: 4.63523,
				stroke: "currentColor",
				strokeWidth: 2
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_27551_8993",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgNoDollarSignSolid;
